import { render } from "./menu.vue?vue&type=template&id=721f30fd&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=721f30fd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-721f30fd"

export default script